import * as React from "react";
import NumberInputWithCommas from "../shared/NumberInputWithCommas";

export default function CumulativeLimitGrid(props: {
  title: string,
  mandatory: boolean,
  limitValue: string,
  intervalValue: string,
  setLimitFunction: (value: string) => void,
  setIntervalFunction: (value: string) => void}
): JSX.Element {
  return (
    <div>
      <h3>Cumulative {props.title}</h3>
      <div className='manage-rc-grid'>
        <label>Limit</label>
        <div>
          <NumberInputWithCommas
            value={props.limitValue}
            onChange={(_, rawValue) => props.setLimitFunction(rawValue)}
            minLength='1'
            maxLength='19' // max 15 string length + 4 commas
            required={props.mandatory || !!props.intervalValue}
          /> {' '}
          <label className='inline-block cumulative-label'>
            JPY per
          </label>
        </div>
        <div>
          <input
            type='number'
            value={props.intervalValue}
            onChange={(event) => props.setIntervalFunction(event.currentTarget.value)}
            className='inline-block input no-margin-bottom text-right'
            min='1'
            max='99999'
            required={props.mandatory || !!props.limitValue}/>{' '}
          <label className='inline-block'>second(s)</label>
        </div>
      </div>
    </div>
  )
}
